import Vue from 'vue';
import VueRouter from 'vue-router';
import config from '@/config';
import { Pages } from '@/util/settings/enums';
Vue.use(VueRouter);
const routes = [
    {
        path: `/${Pages.SIGNUP}`,
        name: Pages.PROFILE,
        component: () => import(/* webpackChunkName: "ProfilePage" */ '@/components/pages/Profile.vue')
    },
    {
        path: `/${config.app.signInPath}`,
        name: Pages.SIGNIN
    },
    {
        path: '/',
        name: 'approot',
        redirect: {
            name: Pages.PROFILE
        }
    },
    {
        path: '/*',
        name: Pages.NOT_FOUND,
        component: () => import(/* webpackChunkName: "NotFoundPage" */ '@/components/pages/NotFound.vue')
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/gmcconnect/' : process.env.BASE_URL,
    routes
});
export default router;
